// src/redux/createEvent/CreateSubCategory/CreateSubCategoryConstants.js

export const FETCH_SUBCATEGORIES_REQUEST = "FETCH_SUBCATEGORIES_REQUEST";
export const FETCH_SUBCATEGORIES_SUCCESS = "FETCH_SUBCATEGORIES_SUCCESS";
export const FETCH_SUBCATEGORIES_FAILURE = "FETCH_SUBCATEGORIES_FAILURE";
